
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useSalesAnalytics = () => {
  return useQuery({
    queryKey: ["sales-analytics"],
    queryFn: async () => {
      // جلب بيانات الحجوزات
      const { data: bookingsData, error: bookingsError } = await supabase
        .from("package_bookings")
        .select(`
          *,
          clients(name_ar, companies(name_ar)),
          employees(name, department)
        `);

      if (bookingsError) throw bookingsError;

      // تحليل المبيعات حسب الشهر
      const monthlySales = bookingsData.reduce((acc: any, booking) => {
        const month = new Date(booking.created_at).toLocaleString('ar-SA', { 
          year: 'numeric', 
          month: 'long' 
        });
        const price = parseFloat(String(booking.price)) || 0;
        if (!acc[month]) {
          acc[month] = { total: 0, count: 0 };
        }
        acc[month].total += price;
        acc[month].count += 1;
        return acc;
      }, {});

      // تحليل أفضل الموظفين مبيعاً
      const employeeSales = bookingsData.reduce((acc: any, booking) => {
        if (booking.employees?.name) {
          const employeeName = booking.employees.name;
          const price = parseFloat(String(booking.price)) || 0;
          if (!acc[employeeName]) {
            acc[employeeName] = { total: 0, count: 0, department: booking.employees.department };
          }
          acc[employeeName].total += price;
          acc[employeeName].count += 1;
        }
        return acc;
      }, {});

      // ترتيب أفضل الموظفين
      const topEmployees = Object.entries(employeeSales)
        .map(([name, data]: [string, any]) => ({
          name,
          total: data.total,
          count: data.count,
          department: data.department,
          average: data.total / data.count
        }))
        .sort((a, b) => b.total - a.total)
        .slice(0, 5);

      // إجمالي المبيعات
      const totalRevenue = bookingsData.reduce((sum, booking) => {
        return sum + (parseFloat(String(booking.price)) || 0);
      }, 0);

      return {
        totalRevenue,
        totalBookings: bookingsData.length,
        monthlySales,
        topEmployees,
        averageOrderValue: totalRevenue / bookingsData.length || 0
      };
    },
  });
};
